import Writers from "./Writers";
import Magazine from "./Magazine";
import Podcasts from "./Podcasts";
import Latest from "./Latest";
import Popular from "./Popular";
import Newsletters from "./Newsletters";
import Crossword from "./Crossword";
import styles from "./HomepageMiddle.module.scss";
import LandingRailAd from "../ads/LandingRail";
import HomepageLeftRailAd from "../ads/compat/HomepageLeftRail";

const HomepageMiddle = () => {
  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <div className={styles.writers}>
          <Writers />
        </div>
        <div className={styles.magazine}>
          <Magazine />
        </div>
        <div className={styles.podcasts}>
          <Podcasts />
        </div>
        <HomepageLeftRailAd />
      </div>
      <div className={styles.middle}>
        <Latest />
      </div>
      <div className={styles.right}>
        <div className={styles.popular}>
          <Popular />
        </div>
        <LandingRailAd targetingPos="hpboxright" />
        <div className={styles.newsletters}>
          <Newsletters />
        </div>
        <div className={styles.crossword}>
          <Crossword />
        </div>
      </div>
    </div>
  );
};

export default HomepageMiddle;
